
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/blog/[slug]",
      function () {
        return require("private-next-pages/[domain]/blog/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/blog/[slug]"])
      });
    }
  